const demo = {
  SITE_URL: 'https://job.veritaris.me',
  API_URL: 'https://job.veritaris.me/api/v1/',
  WEBSOCKET_URL: 'wss://job.veritaris.me/ws',
};

export { demo as default };
